/* oxlint-disable typescript/no-non-null-assertion */
import { IConfig } from '@cian/config/shared';

import { getCommonCategoryLabel } from './commonCategory';
import { serializeCommentsType } from './serializeCommentsType';

export interface ISerializeLabelParams {
  categoryName: string;
  subtitle?: string;
  categoryId?: number;
}

export function serializeLabel(params: ISerializeLabelParams, config?: IConfig): string {
  const { categoryName, subtitle, categoryId } = params;

  switch (categoryName) {
    case 'blogs':
      return 'blog';
    case 'comments':
      return serializeCommentsType(subtitle);
    case 'questions':
      return 'question';
    case 'rq_reviews':
      return 'reviews_jk';
    case 'common_subscriptions':
      return getCommonCategoryLabel(categoryId!, config!); // в случае общих подписок у нас всегда есть categoryId
    default:
      return categoryName;
  }
}
